import { render, staticRenderFns } from "./tempat_pembayaran_SPPT_massal.vue?vue&type=template&id=04de4f30&"
import script from "./tempat_pembayaran_SPPT_massal.vue?vue&type=script&lang=js&"
export * from "./tempat_pembayaran_SPPT_massal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports